import React from 'react';
import { faThumbsUp } from '@fortawesome/pro-regular-svg-icons/faThumbsUp';
import { faThumbsDown } from '@fortawesome/pro-regular-svg-icons/faThumbsDown';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import styles from './OverviewRow.module.scss';
import { Icon, Tooltip } from '@benzinga/core-ui';
import { BullBearStatements, RankingDetail } from '@benzinga/quotes-manager';
import { EdgeRanking } from '@benzinga/ticker-ui';
import { BullsVsBears } from './BullVsBear';

interface RatingsProps {
  up: number;
  down: number;
}

interface OverviewRowProps {
  bullSayBearSay: BullBearStatements | null;
  technicals: RatingsProps;
  financials: RatingsProps;
  className?: string;
  symbol: string;
  rankingData?: RankingDetail | null;
}

export const OverviewRow = ({ bullSayBearSay, rankingData, symbol }: OverviewRowProps) => {
  return (
    <div className={styles.overviewRowWrapper}>
      {/* <OverviewCardWrapper className="flex gap-2 justify-between overview-section">
        <div className="flex flex-row md:justify-normal w-full">
          <SectionRating className="ratings-circle w-[80px] h-[80px]" down={ratings.down} up={ratings.up} />
          <div className="flex flex-col gap-0 md:ml-12 justify-center">
            <div className="font-bold text-gray-600 overview-title">{t('Quote.Analysis.overview-rating')} 12121212</div>
            <div className={`${color} font-semibold text-xl`}>{text}</div>
          </div>
        </div>
      </OverviewCardWrapper> */}

      {rankingData && (
        <div className="flex flex-row gap-2 pb-2">
          <h6 className="uppercase pb-0">Edge Rankings</h6>
          <Tooltip
            content={
              'Benzinga Edge stock rankings give you four critical scores to help you identify the strongest and weakest stocks to buy and sell.'
            }
            width={250}
          >
            <Icon
              className="info-circle-icon text-sm flex items-center justify-center text-[#99AECC]"
              icon={faInfoCircle}
            />
          </Tooltip>
        </div>
      )}

      <div className="edge-items-wrapper flex gap-4">
        {/* {rankingData && <EdgeRankings rankingData={rankingData} />} */}
        {rankingData && (
          <EdgeRanking {...rankingData} adType="quotepage" layout="quote" symbol={symbol} variant="dark" />
        )}
        <div className="bull-vs-bears-wrapper">
          <BullsVsBears statements={bullSayBearSay} symbol={symbol} />
        </div>
      </div>
      {/* <OverviewCardWrapper $height={130}>
        <div className="ratings-section">
          {!!technicalAnalysisRating && (
            <div className={`range-indicator-wrapper ${isEnd(technicalAnalysisRating)}`}>
              <InfoTooltip
                title={t('Quote.Analysis.technicals-analysis', { ns: 'quote' })}
                tooltipContent={t('Quote.Analysis.technicals-analysis-content')}
              />
              <RangeIndicator value={technicalAnalysisRating} />
            </div>
          )}
          {!!technicalAnalysisRating && !!financialAnalysisRating && <Divider />}
          {!!financialAnalysisRating && (
            <div className={`range-indicator-wrapper ${isEnd(financialAnalysisRating)}`}>
              <InfoTooltip
                title={t('Quote.Analysis.financials-analysis', { ns: 'quote' })}
                tooltipContent={t('Quote.Analysis.financials-analysis-content')}
              />
              <RangeIndicator value={financialAnalysisRating} />
            </div>
          )}
        </div>
        <GetReportButton className="w-full mt-2.5 text-sm uppercase" ticker={symbol} variant="flat-light-blue" />
      </OverviewCardWrapper> */}
    </div>
  );
};

export default OverviewRow;

export const Thumb = (props: { up?: boolean; down?: boolean }) => {
  const { down, up } = props;
  if (up) {
    return (
      <div className={`${styles.thumbWrapper} up`}>
        <Icon
          icon={faThumbsUp}
          style={{
            color: '#30bf60',
          }}
        />
      </div>
    );
  }
  if (down) {
    return (
      <div className={`${styles.thumbWrapper} down`}>
        <Icon
          icon={faThumbsDown}
          className="text-sm"
          style={{
            color: '#ff4050',
          }}
        />
      </div>
    );
  }
  return null;
};

